var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ELSAdobeAnalyticService, ELSCommonConfig, ELSCommonUIConstants } from '@els/els-ui-common-react';
import { ADOBE_PRODUCT_CODE, FeatureFlagNames, Language, RoutePath, SYSTEM_ID, USER_ROLE } from 'constants/app.constant';
import { checkPathMatchV2 } from 'helpers/app.helper';
import { Component } from 'react';
import { connect } from 'react-redux';
import { appSelectors } from 'redux/ducks/app';
import { routerSelectors } from 'redux/ducks/route';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { hadSelectors } from 'reports/had/redux/ducks/had';
import { PS_PATHS } from 'reports/ps/constants';
import { SH_PATHS } from 'reports/sh/constants/sh.constant';
import { shSelectors } from 'reports/sh/redux/ducks/sh';
import { isFeatureEnabled } from 'services/feature-flag.service';
import { ELSTokenHelper } from '..';
var AdobeAnalyticsInit = /** @class */ (function (_super) {
    __extends(AdobeAnalyticsInit, _super);
    function AdobeAnalyticsInit(props) {
        var _this = _super.call(this, props) || this;
        _this.getUserRole = function () {
            var _a;
            var token = ELSTokenHelper.getToken();
            return _this.props.userRole || (token && ((_a = ELSTokenHelper.decode(token)) === null || _a === void 0 ? void 0 : _a.role));
        };
        // ToDo: data manipulation logic here is shared with PendoInit. Move to a parent component
        _this.registerAdobeAnalytics = function () {
            var _a, _b, _c, _d;
            var _e = _this.props, courseSectionInfo = _e.courseSectionInfo, evolveUser = _e.evolveUser, evolveUserLoading = _e.evolveUserLoading, featureFlags = _e.featureFlags, programName = _e.programName, programId = _e.programId, userId = _e.userId, instructorId = _e.instructorId;
            var courseId = ((_a = courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.id) === null || _a === void 0 ? void 0 : _a.toString()) || '';
            var accountId = ((_c = (_b = courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.institution) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.toString()) || '';
            var accountName = ((_d = courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.institution) === null || _d === void 0 ? void 0 : _d.name) || '';
            var prefix = SYSTEM_ID.EOLS;
            var role = _this.getUserRole();
            if (!userId || !role) {
                return;
            }
            var locationsHash = window.location.hash.toLowerCase();
            // if we're on SH, we might not have institution id, so we need to use instructor id
            if (checkPathMatchV2(Object.values(SH_PATHS))) {
                accountId = accountId || (instructorId === null || instructorId === void 0 ? void 0 : instructorId.toString());
                accountName = accountName || 'shadowhealth-user';
            }
            else if (!accountId && !accountName && checkPathMatchV2(__spreadArray(__spreadArray([], Object.values(PS_PATHS), true), [RoutePath.reportingPortal], false))) {
                // if we navigate from Evolve, we might not have courseSectionInfo, so we need to use user id and user name
                accountId = userId;
                accountName = evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.userName;
            }
            else {
                // If 'Courseware' or 'Hesi Readiness', we need to wait 'courseSectionInfo + evolveUser' done to register Pendo
                if (locationsHash !== "#".concat(RoutePath.had.toLowerCase())) {
                    if (!courseId) {
                        return;
                    }
                    if ((featureFlags || []).length > 0) {
                        // TODO: comment on the purpose of this flag or remove the flag
                        var enabledEvolveIdOnAnalyticsFlag = isFeatureEnabled(featureFlags, FeatureFlagNames.EVOLVE_ID_ON_ANALYTICS_ENABLED, courseId);
                        if (enabledEvolveIdOnAnalyticsFlag && evolveUserLoading) {
                            return;
                        }
                        if (enabledEvolveIdOnAnalyticsFlag && !evolveUserLoading && evolveUser) {
                            prefix = SYSTEM_ID.EVOLVE;
                        }
                    }
                }
                // if we're on NCLEX, we might not have institution id, so we need to use program id
                if (locationsHash === "#".concat(RoutePath.had.toLowerCase())) {
                    accountId = !accountId ? programId.toString() : accountId;
                    accountName = !accountName ? programName : accountName;
                }
            }
            if (!accountId || !accountName) {
                return;
            }
            var registrationConfig = {
                accountId: "".concat(prefix, ":").concat(accountId),
                accountName: "".concat(prefix, ":").concat(accountName),
                businessUnit: 'els:nh',
                cmsName: '',
                language: Language.DEFAULT_LOCALE,
                productName: ADOBE_PRODUCT_CODE.SHERPATH_COURSEWARE,
                userId: "".concat(prefix, ":").concat(userId)
            };
            // Reset the configs as to not inherit old configs
            // Consider adding this to the internal ELSAdobeAnalyticService.registerAdobeAnalytic method logic
            ELSAdobeAnalyticService.resetService();
            // ELSAdobeAnalyticService calls this url to check whether adobe analytics is enabled
            // Only register Adobe Analytic after logging in because it's required the user token
            var adobeFeatureApiUrl = "".concat(ELSCommonConfig.buildUrl, "/api/features/app/").concat(ELSCommonUIConstants.appIds.PERFORMANCE_REPORT, "/key/ADOBE_ANALYTICS_DISABLED");
            ELSAdobeAnalyticService.registerAdobeAnalytic(adobeFeatureApiUrl, registrationConfig);
            _this.setState({ isAdobeAnalyticsRegistered: true });
        };
        _this.forceUpdatePageData = function () {
            var _a, _b, _c, _d, _e, _f, _g;
            var _h = _this.props, courseSectionInfo = _h.courseSectionInfo, evolveUser = _h.evolveUser, evolveUserLoading = _h.evolveUserLoading, featureFlags = _h.featureFlags, programName = _h.programName, programId = _h.programId, userId = _h.userId, userRole = _h.userRole, instructorId = _h.instructorId;
            var aaData = window === null || window === void 0 ? void 0 : window.pageData;
            var aaPage = (_a = window === null || window === void 0 ? void 0 : window.pageData) === null || _a === void 0 ? void 0 : _a.page;
            var aaVisitor = (_b = window === null || window === void 0 ? void 0 : window.pageData) === null || _b === void 0 ? void 0 : _b.visitor;
            var aaEducation = (_c = window === null || window === void 0 ? void 0 : window.pageData) === null || _c === void 0 ? void 0 : _c.education;
            var courseId = ((_d = courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.id) === null || _d === void 0 ? void 0 : _d.toString()) || '';
            var accountId = ((_f = (_e = courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.institution) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.toString()) || '';
            var accountName = ((_g = courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.institution) === null || _g === void 0 ? void 0 : _g.name) || '';
            var prefix = SYSTEM_ID.EOLS;
            // do not update if there's are already details and an education object
            if (!userId || !userRole) {
                return;
            }
            var locationsHash = window.location.hash.toLowerCase();
            // if we're on SH, we might not have institution id, so we need to use instructor id
            if (checkPathMatchV2(Object.values(SH_PATHS))) {
                accountId = accountId || instructorId.toString();
                accountName = accountName || 'shadowhealth-user';
            }
            else if (!accountId && !accountName && checkPathMatchV2(__spreadArray(__spreadArray([], Object.values(PS_PATHS), true), [RoutePath.reportingPortal], false))) {
                // if we navigate from Evolve, we might not have courseSectionInfo, so we need to use user id and user name
                accountId = userId;
                accountName = evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.userName;
            }
            else {
                // If 'Courseware' or 'Hesi Readiness', we need to wait 'courseSectionInfo + evolveUser' done to register Pendo
                if (locationsHash !== "#".concat(RoutePath.had.toLowerCase())) {
                    if (!courseId) {
                        return;
                    }
                    if ((featureFlags || []).length > 0) {
                        // TODO: comment on the purpose of this flag or remove the flag
                        var enabledEvolveIdOnAnalyticsFlag = isFeatureEnabled(featureFlags, FeatureFlagNames.EVOLVE_ID_ON_ANALYTICS_ENABLED, courseId);
                        if (enabledEvolveIdOnAnalyticsFlag && evolveUserLoading) {
                            return;
                        }
                        if (enabledEvolveIdOnAnalyticsFlag && !evolveUserLoading && evolveUser) {
                            prefix = SYSTEM_ID.EVOLVE;
                        }
                    }
                }
                // if we're on NCLEX, we might not have institution id, so we need to use program id
                if (locationsHash === "#".concat(RoutePath.had.toLowerCase())) {
                    accountId = !accountId ? programId.toString() : accountId;
                    accountName = !accountName ? programName : accountName;
                }
            }
            if (!accountId || !accountName) {
                return;
            }
            var educationData = aaEducation || {};
            if (userRole.toLowerCase() === USER_ROLE.EOLS_INSTRUCTOR.toLowerCase() || userRole.toLowerCase() === USER_ROLE.EVOLVE_INSTRUCTOR.toLowerCase()) {
                Object.assign(educationData, { instructorId: "".concat(prefix, ":").concat(userId) });
            }
            else if (userRole.toLowerCase() === USER_ROLE.STUDENT.toLowerCase()) {
                Object.assign(educationData, { studentId: "".concat(prefix, ":").concat(userId) });
            }
            var visitorData = __assign(__assign({}, aaVisitor), { accountId: "".concat(prefix, ":").concat(accountId), accountName: "".concat(prefix, ":").concat(accountName), userId: "".concat(prefix, ":").concat(userId), details: userRole });
            var pageData = __assign(__assign({}, aaPage), { language: Language.DEFAULT_LOCALE, businessUnit: 'els:nh' });
            ELSAdobeAnalyticService.trackEvent(ELSCommonUIConstants.analytics.eventTypes.newPage, __assign(__assign({}, aaData), { visitor: visitorData, page: pageData, education: educationData }));
            _this.setState({ isPageDataUpdated: true });
        };
        _this.state = {
            isAdobeAnalyticsRegistered: false,
            isPageDataUpdated: false
        };
        return _this;
    }
    AdobeAnalyticsInit.prototype.componentDidMount = function () {
        var _a;
        // The @els/els-ui-common-react AdobeAnalyticService module initialises its eventQueue with a
        // dummy entry { eventName: 'EVENT_1', pageData: 'PAGE_DATA_1' }.  When any trackEvent call
        // is made, processEventQueue dequeues this entry first and passes the string 'PAGE_DATA_1'
        // to window.pageDataTracker.trackEvent, whose CDN implementation tries to set
        // pageData.eventName = eventName — throwing "Cannot create property 'eventName' on string
        // 'PAGE_DATA_1'".  Patching the method here silently discards non-object pageData payloads
        // so the dummy entry is consumed without error.
        if (typeof ((_a = window.pageDataTracker) === null || _a === void 0 ? void 0 : _a.trackEvent) === 'function') {
            var originalTrackEvent_1 = window.pageDataTracker.trackEvent.bind(window.pageDataTracker);
            window.pageDataTracker.trackEvent = function (eventName, pageData) {
                if (!pageData || typeof pageData !== 'object')
                    return;
                originalTrackEvent_1(eventName, pageData);
            };
        }
        if (!this.state.isAdobeAnalyticsRegistered && this.props.isAllAADataCollected) {
            this.registerAdobeAnalytics();
        }
    };
    AdobeAnalyticsInit.prototype.componentDidUpdate = function () {
        if (!this.state.isAdobeAnalyticsRegistered && this.props.isAllAADataCollected) {
            this.registerAdobeAnalytics();
            return;
        }
        if (this.state.isAdobeAnalyticsRegistered && !this.state.isPageDataUpdated && this.props.isAllAADataCollected) {
            this.forceUpdatePageData();
        }
    };
    AdobeAnalyticsInit.prototype.render = function () {
        return null;
    };
    return AdobeAnalyticsInit;
}(Component));
var mapStateToProps = function (state) { return ({
    courseSectionInfo: courseSelectors.getCourseSectionInfo(state),
    isbn: appSelectors.getIsbn(state),
    userId: appSelectors.getUserId(state),
    userRole: appSelectors.getUserRole(state),
    evolveUser: appSelectors.getEvolveUser(state),
    evolveUserLoading: appSelectors.getEvolveUserLoading(state),
    featureFlags: appSelectors.getFeatureFlags(state),
    location: routerSelectors.getLocation(state),
    programId: hadSelectors.getProgramId(state),
    programName: hadSelectors.getProgramName(state),
    instructorId: shSelectors.getInstructorId(state),
    isAllAADataCollected: appSelectors.getIsAllAADataCollected(state)
}); };
export default connect(mapStateToProps)(AdobeAnalyticsInit);
